import { useLinkTo } from '../../../../hooks';
import analytics from '../../../../modules/analytics';
import { bulkImportSupported, openAppDownloadDialog } from '../../../../modules/provider/Client/importContacts';
import { PRO_CLIENT_IMPORT } from '../../../../route-names';

export const ITERATION_KEY = 'add-upload-secure-012018';

/**
 * This hook is meant for handling navigation to the import contacts page
 * (or opening the download mobile app modal). If you need to open the import contacts
 * modal over your current page, use the useBulkImportModalHandler hook instead.
 */
export function useBulkImportHandler(routeName: string, source: string): () => void {
  const linkTo = useLinkTo();

  return () => {
    const params = {
      pro_add_clients_method: 'bulk-import',
      pro_add_client_source: ITERATION_KEY,
      source: source || 'Client Empty State',
    };
    analytics.track('P Clicked Add New Client', params);

    if (bulkImportSupported()) {
      linkTo(
        PRO_CLIENT_IMPORT,
        { returnRoute: routeName },
        true,
        false,
      );
    } else {
      openAppDownloadDialog();
    }
  };
}
